import { Accordion } from "flowbite-react";
import React from "react";

const ProductDescriptionSection = ({ productDetails }) => {
  const categoryDesc = productDetails?.category?.description
    ? JSON.parse(productDetails.category.description)
    : null;


  return (
    <div className="mb-4"> {/* Reduced margin-bottom */}
      <Accordion collapseAll={true}>
        <Accordion.Panel>
          <Accordion.Title className="text-sm p-3 border-0 font-medium">
            Description
          </Accordion.Title>
          <Accordion.Content>
            <div className="space-y-2 text-sm"> {/* Adjusted spacing and font size */}
              {/* Category Description Title */}
              {categoryDesc?.title && (
                <h2 className="text-xl font-bold text-gray-800 dark:text-white">
                  {categoryDesc.title}
                </h2>
              )}

              {/* Category Features */}
              {categoryDesc?.features?.length > 0 && (
                <div className="space-y-1 pl-3"> {/* Adjusted spacing and padding */}
                  {categoryDesc.features.map((feature, index) => (
                    <p
                      key={index}
                      className="flex items-start text-gray-700 dark:text-gray-400"
                    >
                      <span className="mr-2 font-up">-</span>
                      <span className="font-light font-up">{feature}</span>
                    </p>
                  ))}
                </div>
              )}
            </div>
          </Accordion.Content>
        </Accordion.Panel>
      </Accordion>
    </div>
  );
};

export default ProductDescriptionSection;
